import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const Billing_refunded = () => {
  return (
    <div>
      {/* <?php $bodyClass = 'pg-legacy'; ?>
<?php  include('head_meta.php');  ?>
<?php  include('header.php');  ?> */}
      <Header>
        <div className="content">
          <div class="mob_nav">
            <div class="row">
              <div class="col-7">
                <div class=" d-flex justify-content-start ">
                  <a href="javascript:window.history.back();" class="">
                    <i class="bi bi-arrow-left"></i>
                  </a>
                  <h2>Refund</h2>
                </div>
              </div>
              <div class="col"></div>
            </div>
          </div>

          <div class="row justify-content-between desk_nav">
            <div class="col-12 col-md-4 ">
              <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-90deg-left"></i>
                </a>
                <h2>Refund</h2>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3"></div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <div class="row justify-content-between">
                <div class="col-12 col-md-6 mb-1">
                  <div class="row g-1">
                    <div class="col-12 col-md-6">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control custom-daterange"
                        />
                        <span class="input-group-text">
                          <i class="bi bi-calendar2-range"></i>
                        </span>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="search-box">
                        <div class="search-icon">
                          <i class="bi bi-search"></i>
                        </div>
                        <input
                          type="text"
                          class="search-input"
                          placeholder="Search ..."
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 mb-1">
                  <div class="row justify-content-between">
                    <div class="col-6 col-md">
                      <div class="row">
                        <div class="col-12 col-md">
                          <a
                            href=""
                            class="btn btn-outline-secondary btn-block"
                          >
                            View Report
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 col-md-4 text-end">
                      <a href="" class="btn btn-outline-secondary btn-block">
                        Download Report
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card data_table mb-3 ">
            <div class="card-body">
              <div class="table-responsive">
                <div class="shipm_tablew rounded-3">
                  <table class="table align-top table-striped table-hover m-0 table-xl ">
                    <thead>
                      <tr>
                        <th width="170px">Date</th>
                        <th width="140px">Transaction ID</th>
                        <th width="">Order Number</th>
                        <th width="200px">AWB Number</th>
                        <th>Weight & Zone</th>
                        <th>Carrier</th>
                        <th>Particluars</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="">
                        <td>
                          <small>Aug 21 2024 - 01:59:37 pm</small>
                        </td>
                        <td>
                          <a href="#" class="text-primary">
                            22484610105210
                          </a>
                        </td>
                        <td>
                          <h6>
                            <a href="#" class="text-primary">
                              1724228987370
                            </a>
                          </h6>
                        </td>
                        <td>
                          <h6>
                            <a href="#" class="text-primary">
                              1724228987370
                            </a>
                          </h6>
                        </td>
                        <td>
                          1 KG
                          <small>Local Zone</small>
                        </td>
                        <td>DELHIVERY 1KG</td>
                        <td>Shipment Cancellation</td>
                        <td>
                          <span class="text-success">₹200</span>
                        </td>
                      </tr>
                      <tr class="">
                        <td>
                          <small>Aug 21 2024 - 01:59:37 pm</small>
                        </td>
                        <td>
                          <a href="#" class="text-primary">
                            22484610105210
                          </a>
                        </td>
                        <td>
                          <h6>
                            <a href="#" class="text-primary">
                              1724228987370
                            </a>
                          </h6>
                        </td>
                        <td>
                          <h6>
                            <a href="#" class="text-primary">
                              1724228987370
                            </a>
                          </h6>
                        </td>
                        <td>
                          1 KG
                          <small>Local Zone</small>
                        </td>
                        <td>DELHIVERY 1KG</td>
                        <td>Order Failed</td>
                        <td>
                          <span class="text-success">₹200</span>
                        </td>
                        <td>
                          <span class="text-danger"></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Billing_refunded;
